import type { AdminRole } from "@/lib/permissions/roles";

export interface AdminSession {
  adminId: string;
  email: string;
  displayName: string;
  role: AdminRole;
  mfaEnabled: boolean;
  signedInAt: string;
  // Optional environment label e.g. "production · us-west · live"
  environmentLabel: string;
  /**
   * Backend-granted permission strings from `/admin/auth/me` (real mode).
   * The server's role/permission config is authoritative; when present this
   * is what the settings page displays. Absent in mock mode — the UI then
   * falls back to the client-side role→permissions map for fixtures.
   */
  permissions?: string[];
}

export type AdminSessionState =
  | { status: "loading" }
  | { status: "unauthenticated" }
  | { status: "authenticated"; session: AdminSession };

/**
 * Placeholder session used by the AdminAuthProvider until backend integration.
 * Treat as MOCK ONLY — real sessions must come from /admin/auth/session.
 */
export const MOCK_ADMIN_SESSION: AdminSession = {
  adminId: "adm_01HXYZ",
  email: "ada.tran@wear.zone",
  displayName: "Ada Tran",
  role: "owner",
  mfaEnabled: true,
  signedInAt: new Date().toISOString(),
  environmentLabel: "Production · us-west · live",
};
